/**
 * Created by Qingger Corp.
 * User: Thinkpad
 * Date: 2018/5/31
 * Time: 16:28
 * Desc: 关键词配置
 */

import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import collect from 'collect.js';
import { isEmpty } from 'lodash';
import { globalElement } from '@/library/utils/globalElement';

@Component({
  components: {},
})
export default class ConfigureKeywords extends Vue {
  @Prop({ default: '' }) navTitle: string;
  @Prop({ default: [] }) configColumns: ItemArray<ActTypeColumns>;
  @Prop({ default: [] }) checkedColumns: ItemArray<ActTypeColumns>;
  @Prop({ default: false }) defaultColumn: boolean;
  // 是否显示单选
  @Prop({ default: false }) isShowRadio: boolean;
  @Prop({ default: false }) isSignUp: boolean;
  /**
   * 默认配置的活动项关键词
   */
  public defaultActColumns: ItemArray<ActTypeColumns> = [
    {
      column_title: '活动封面',
      column_name: 'act_cover',
      column_type: 'img',
      column_format: '',
      column_length: '0',
      column_required: 1,
      rule_required: '',
      is_custom: 0,
    },
    {
      column_title: '活动标题',
      column_name: 'act_title',
      column_type: 'input',
      column_format: '',
      column_length: '0',
      column_required: 1,
      rule_required: '',
      is_custom: 0,
    },
  ];

  /* 默认配置报名项 */
  public defaultSignUpColumn: ActTypeColumns = {
    column_title: '手机号',
    column_name: 'mobile',
    column_type: 'input',
    column_format: 'number',
    column_length: '11',
    column_required: 1,
    rule_required: '^1(3|4|5|6|7|8|9)\\d{9}$',
    is_custom: 0,
  };

  /* 关键词类型 */
  public keywordType: Array<any> = [
    {
      value: 'input',
      label: '文本',
    },
    {
      value: 'textarea',
      label: '多行文本',
    },
    {
      value: 'datetime',
      label: '日期',
    },
    {
      value: 'radio',
      label: '单选',
    },
    {
      value: 'citypicker',
      label: '省市区',
    },
  ];

  /* 日期类型 */
  public dateFormat: Array<any> = [
    {
      value: 'y-m-d',
      label: '年月日',
    },
    {
      value: 'y-m-d H:i',
      label: '年月日时分',
    },
  ];

  /**
   * 是否显示自定义添加关键词窗口
   * @type {boolean}
   */
  public isShowAddColumn = false;

  /**
   * 是否显示编辑关键字窗口
   * @type {boolean}
   */
  public isShowEditColumn = false;

  // 被编辑的关键字下标
  public selectIndex = -1;

  // 被编辑的关键字对象
  public customItem: ActTypeColumns = {};

  /**
   * 自定义添加列
   * @type {any[]}
   */
  public customColumns: ItemArray<ActTypeColumns> = [];

  /**
   * 已选择活动项的关键词
   * @type {any[]}
   */
  public checkedColumnArr: ItemArray<ActTypeColumns> = [];

  public checkedIds: ItemArray<any> = [];

  /**
   * 可选择的活动项关键词
   * @type {any[]}
   */
  public configColumnArr: ItemArray<ActTypeColumns> = [];

  public copyString = '';

  /**
   * 打开自定义关键词弹窗
   */
  showAddColumn() {
    this.isShowAddColumn = true;
    this.addedColumn();
  }

  /**
   * 新增关键词
   */
  addedColumn() {
    const name = `column-${this.getUniqueId(5)}`;

    const item: ActTypeColumns = {
      column_title: '',
      column_name: name,
      column_type: '',
      column_format: '',
      column_length: '0',
      column_required: 0,
      rule_required: '',
      is_custom: 1,
      column_choose_valus: [{ name: '' }],
    };

    this.customColumns.push(item);
  }

  /**
   * 自定义关键词输入正整数验证
   * @param index
   */
  inputNumber(index) {
    this.customColumns[index].column_length = this.customColumns[index].column_length.replace(/[^\d.]/g, '');
    this.customColumns[index].column_length = this.customColumns[index].column_length.replace('.', '');
  }

  /**
   * 编辑关键词正整数验证
   */
  itemInputNumber() {
    this.customItem.column_length = this.customItem.column_length.replace(/[^\d.]/g, '');
    this.customItem.column_length = this.customItem.column_length.replace('.', '');
  }

  /**
   * 设置值
   * @param value
   */
  handleCheckedChange(value) {
    this.checkedIds = value;
    this.checkedColumnArr = collect(this.configColumnArr).whereIn('column_name', value).toArray();
    this.$emit('changeCheckColumn', this.checkedColumnArr, this.defaultColumn ? 'ACT' : 'SIGN-UP');
  }

  /**
   * 打印拖拽后的列表
   */
  sortActIndex() {
    collect(this.checkedColumnArr)
      .map<number>((item, index): any => {
        return item;
      })
      .all();
    this.$emit('changeCheckColumn', this.checkedColumnArr, this.defaultColumn ? 'ACT' : 'SIGN-UP');
  }

  /**
   * 删除自定义关键字
   * @param item
   */
  deleteColumn(item) {
    const self = this;
    self
      .$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning',
      })
      .then(() => {
        const configIndex = self.configColumnArr.indexOf(item);
        if (configIndex !== -1) {
          self.configColumnArr.splice(configIndex, 1);
        }
        // let checkedIndex = self.checkedColumnArr.indexOf(item);
        const checkedIndex = self.checkedColumnArr.map(item => item.column_name).indexOf(item.column_name);
        if (checkedIndex !== -1) {
          self.checkedColumnArr.splice(checkedIndex, 1);
        }
      });
    this.$emit('changeCheckColumn', this.checkedColumnArr, this.defaultColumn ? 'ACT' : 'SIGN-UP');
  }

  /**
   * 删除未保存的自定义关键字
   * @param item
   */
  deleteKeyword(item) {
    const index = this.customColumns.indexOf(item);
    if (index !== -1) {
      this.customColumns.splice(index, 1);
    }
  }

  /**
   * 确定提交自定义关键字数据
   */
  confirmCutData() {
    if (isEmpty(this.customColumns)) {
      globalElement.message.warning('请添加关键词');
      return;
    }
    const info = this.customColumns.filter((item) => {
      return item.column_title == '' || item.column_type == '' || (item.column_type == 'radio' && !item.column_choose_valus.length) || (item.column_type == 'datetime' && item.column_format == '') || item.column_length == '';
    });
    if (!isEmpty(info)) {
      globalElement.message.warning('请确认关键词信息都已填写或选择');
      return;
    }
    const customName = collect(this.customColumns).pluck('column_title').toArray();
    const configName = collect(this.configColumnArr).pluck('column_title').toArray();
    const merges = customName.concat(configName);
    if (this.isRepeat(merges)) {
      globalElement.message.warning('存在相同关键词，请修改');
      return;
    }

    this.configColumnArr = this.configColumnArr.concat(this.customColumns);

    this.customColumns.forEach((item) => {
      if (item.column_type === 'radio') {
        this.checkedColumns.splice(this.checkedColumns.length, 1, item);
      }
    });

    globalElement.message.success('已添加');
    this.customColumns = [];
    this.isShowAddColumn = false;
  }

  // 判断是否有重复
  isRepeat(arr) {
    const hash = {};
    for (const i in arr) {
      if (hash[arr[i]]) {
        return true;
      }
      hash[arr[i]] = true;
    }
    return false;
  }

  /**
   * 编辑关键字
   * @param item
   * @param index
   */
  editColumn(item, index) {
    this.selectIndex = index;
    this.customItem = JSON.parse(JSON.stringify(item));
    if (this.customItem.column_type === 'radio' && !this.customItem.column_choose_valus) {
      this.customItem = Object.assign({}, this.customItem, { column_choose_valus: [] });
      this.customItem.column_choose_valus.splice(this.customItem.column_choose_valus.length, 1, { name: '' });
      this.customItem = Object.assign({}, this.customItem, {
        column_choose_valus: this.customItem.column_choose_valus,
      });
    }

    this.configColumnArr.splice(this.selectIndex, 1, this.customItem);

    this.isShowEditColumn = true;
  }

  isShow(item) {
    if (
      item
      && item.column_required === 1
      && item.column_name !== 'act_cover'
      && item.column_name !== 'act_title'
      && item.column_name !== 'act_begin_time'
      && item.column_name !== 'act_end_time'
      && item.column_name !== 'act_order_end_time'
      && item.column_name !== 'act_order_begin_time'
      && item.column_name !== 'act_points'
    ) {
      return 1;
    } else if ((item && item.column_name === 'act_begin_time') || item.column_name === 'act_end_time' || item.column_name === 'act_order_end_time' || item.column_name === 'act_order_begin_time' || item.column_name === 'act_points') {
      return 0;
    } else {
      return 2;
    }
  }

  /**
   * 单个checkbox变更状态
   * @param item
   */
  boxChange(item) {
    if (item.column_required === 0) {
      const name = item.column_name;
      const nameIndex = this.checkedIds.indexOf(name);
      if (nameIndex !== -1) {
        this.checkedIds.splice(nameIndex, 1);
      }

      const index = this.checkedColumnArr.indexOf(item);
      if (index !== -1) {
        this.checkedColumnArr.splice(index, 1);
      }
      const self = this;
      const arr: ItemArray<ActTypeColumns> = JSON.parse(JSON.stringify(this.checkedColumnArr));
      self.checkedColumnArr = [];
      this.$nextTick(() => {
        arr.forEach((item) => {
          self.checkedColumnArr.push(item);
        });
      });
      this.$emit('changeCheckColumn', this.checkedColumnArr, this.defaultColumn ? 'ACT' : 'SIGN-UP');
    } else {
      this.$notify({
        title: '警告',
        message: `必填项【${item.column_title}】不可删除`,
        type: 'warning',
        showClose: false,
      });
    }
  }

  /**
   * 设置是否必填
   * @param index
   * @param state
   */
  setItemRequired(index, state) {
    this.checkedColumnArr[index].column_required = state;
    this.$emit('changeCheckColumn', this.checkedColumnArr, this.defaultColumn ? 'ACT' : 'SIGN-UP');
  }

  /**
   * 当前选择类型
   * @param index
   * @param value
   */
  selectType(index, value) {
    const name = `citypicker-${this.getUniqueId(5)}`;
    if (index == -1) {
      this.customItem.column_type = value;
    } else {
      this.customColumns[index].column_type = value;
    }

    if (value === 'radio') {
      if (index == -1) {
        this.customItem.column_required = 1;

        !this.customItem.column_choose_valus && this.addRadioItem();
      } else {
        this.customColumns[index].column_required = 1;

        !this.customColumns[index].column_choose_valus && this.addRadio(0);
      }
    }
    if (value === 'citypicker') {
      if (index == -1) {
        this.customItem.column_name = 'citypicker';
      } else {
        this.customColumns[index].column_name = name;
      }
    }
  }

  /**
   * 当前选择时间格式
   * @param index
   * @param value
   */
  selectDateFormat(index, value) {
    if (index == -1) {
      this.customItem.column_format = value;
    } else {
      this.customColumns[index].column_format = value;
    }
  }

  /**
   * radio添加选择项
   * @param index
   */
  addRadio(index) {
    this.customColumns[index].column_choose_valus.splice(this.customColumns[index].column_choose_valus.length, 1, {
      name: '',
    });
    this.customColumns.splice(index, 1, this.customColumns[index]);
  }

  /**
   * 删除radio选择项
   * @param index
   * @param radioIndex
   */
  delRadio(index, radioIndex) {
    this.customColumns[index].column_choose_valus.splice(radioIndex, 1);
    this.customColumns.splice(index, 1, this.customColumns[index]);
  }

  /**
   * radio添加选择项 编辑
   */
  addRadioItem() {
    this.customItem.column_choose_valus.splice(this.customItem.column_choose_valus.length, 1, { name: '' });
    // this.customColumns.splice(index, 1,this.customColumns[index]);

    this.customItem = Object.assign({}, this.customItem, { column_choose_valus: this.customItem.column_choose_valus });
  }

  /**
   * 删除radio选择项 编辑
   * @param radioIndex
   */
  delRadioItem(radioIndex) {
    this.customItem.column_choose_valus.splice(radioIndex, 1);
    // this.customColumns.splice(index, 1,this.customColumns[index]);
    this.customItem = Object.assign({}, this.customItem, { column_choose_valus: this.customItem.column_choose_valus });
  }

  /**
   * 取消后重置数据
   */
  cancelCutData() {
    this.customColumns = [];
    this.isShowAddColumn = false;
  }

  /**
   * 取消后重置数据
   */
  cancelItem() {
    this.customItem = {};
    this.selectIndex = -1;
    this.isShowEditColumn = false;
  }

  /**
   * 提交编辑数据
   */
  confirmItem() {
    if (this.customItem.column_title == '' || this.customItem.column_type == '' || (this.customItem.column_type == 'datetime' && this.customItem.column_format == '')) {
      globalElement.message.warning('请确认关键词信息都已填写或选择');
      return;
    }

    this.configColumnArr[this.selectIndex] = this.customItem;

    this.checkedColumnArr = collect(this.configColumnArr).whereIn('column_name', this.checkedIds).toArray();
    this.$emit('changeCheckColumn', this.checkedColumnArr, this.defaultColumn ? 'ACT' : 'SIGN-UP');

    this.customItem = {};
    this.isShowEditColumn = false;
    this.selectIndex = -1;
  }

  /**
   * 生成唯一id
   * @param length
   * @returns {string}
   */
  getUniqueId(length) {
    // eslint-disable-next-line unicorn/prefer-string-slice
    return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
  }

  public created() {
    this.configColumnArr = this.configColumns;
    this.checkedColumnArr = this.checkedColumns;
    if (!this.defaultColumn) {
      this.configColumnArr.concat([this.defaultSignUpColumn]);
    }
    this.checkedIds = collect(this.checkedColumns).pluck('column_name').toArray();
  }

  @Watch('configColumns', { deep: true })
  watchData() {
    this.configColumnArr = JSON.parse(JSON.stringify(this.configColumns));
  }

  @Watch('checkedColumns', { deep: true })
  watchCheck() {
    this.checkedColumnArr = this.checkedColumns;
    this.checkedIds = collect(this.checkedColumns).pluck('column_name').toArray();

  }
}
